<template>
  <div>
    <div class="mb-1 w-auto text-xs">
      {{ name }}
    </div>
    <div class="flex items-center justify-start gap-1.5">
      <div v-show="preContext" class="text-xs">{{ preContext }}</div>
      <VueNumberInput
        v-model="numVal"
        :step="step"
        :max="max"
        :min="min"
        :size="size"
        :placeholder="placeholder"
        :inputtable="inputtable"
        :disabled="disabled"
        inline
        center
        controls
        @update:model-value="onChange"
      />
      <div v-show="postContext" class="text-xs">{{ postContext }}</div>
    </div>
  </div>
</template>

<script>
import VueNumberInput from '@chenfengyuan/vue-number-input';

import { computed, defineComponent } from 'vue';
export default defineComponent({
  /**
   * 最初註冊名稱與檔案名稱開頭大小寫不一致，故針對此命名（Histoire 讀檔用）
   */
  name: 'NumberField',
  components: {
    VueNumberInput
  },
  props: {
    modelValue: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'Small'
    },
    step: {
      type: Number,
      default: 1
    },
    min: {
      type: Number,
      default: -Infinity
    },
    max: {
      type: Number,
      default: Infinity
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    inputtable: {
      type: Boolean,
      default: true
    },
    preContext: {
      type: String,
      default: ''
    },
    postContext: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue', 'change'],
  setup(props, { emit }) {
    const numVal = computed({
      get: () => props.modelValue,
      set: (val) => {
        emit('update:modelValue', val);
      }
    });
    function onChange(newValue, oldValue) {
      if (newValue !== oldValue) {
        emit('change', newValue, oldValue);
      }
    }
    return {
      numVal,
      onChange
    };
  }
});
</script>